import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15d6ac74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-bg-white tw-pt-[17px] tw-pb-[16px] !tw-px-[20px] xl:!tw-px-[60px] tw-relative tw-w-full tw-flex tw-justify-between tw-items-center active-path-header_wrapper" }
const _hoisted_2 = { class: "tw-flex tw-flex-wrap tw-gap-[15px] tw-m-0 tw-w-full" }
const _hoisted_3 = { class: "tw-flex-grow tw-p-0" }
const _hoisted_4 = { class: "tw-flex tw-items-center tw-h-full" }
const _hoisted_5 = { class: "tw-flex-grow-0 tw-w-full sm:tw-w-auto tw-p-0" }
const _hoisted_6 = { class: "group-button-action tw-flex tw-flex-nowrap tw-justify-start sm:tw-justify-end tw-gap-[20px] tw-items-center tw-p-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_active_path_header = _resolveComponent("active-path-header")!
  const _component_Button1 = _resolveComponent("Button1")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_active_path_header, {
            path: _ctx.activeHierarchy,
            navigate: _ctx.navigate
          }, null, 8, ["path", "navigate"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.buttonTitle)
            ? (_openBlock(), _createBlock(_component_Button1, {
                key: 0,
                id: _ctx.idButton1,
                "data-cy": _ctx.dataCy1,
                class: _normalizeClass(`tw-min-w-[136px] button ${_ctx.buttonClass} ${
              _ctx.isOutline ? 'button-outline' : ''
            }`),
                title: _ctx.buttonTitle,
                disabled: _ctx.isButtonEnable,
                "is-outline": _ctx.isOutline,
                "is-loading": _ctx.isBtnLoading,
                "css-button": 'tw-whitespace-nowrap',
                onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('click-button'))
              }, null, 8, ["id", "data-cy", "class", "title", "disabled", "is-outline", "is-loading"]))
            : _createCommentVNode("", true),
          (_ctx.button2Title)
            ? (_openBlock(), _createBlock(_component_Button1, {
                key: 1,
                id: _ctx.idButton2,
                "data-cy": _ctx.dataCy2,
                class: _normalizeClass(`button ${_ctx.isOutline2 ? 'button-outline' : ''}`),
                title: _ctx.button2Title,
                disabled: _ctx.isButton2Enable,
                "is-loading": _ctx.isBtn2Loading,
                "css-button": 'tw-whitespace-nowrap',
                onClick: _cache[1] || (_cache[1] = () => _ctx.$emit('click-button2'))
              }, null, 8, ["id", "data-cy", "class", "title", "disabled", "is-loading"]))
            : _createCommentVNode("", true),
          (_ctx.button3Title)
            ? (_openBlock(), _createBlock(_component_Button1, {
                key: 2,
                id: _ctx.idButton3,
                class: _normalizeClass(`button ${_ctx.isOutline2 ? 'button-outline' : ''}`),
                title: _ctx.button3Title,
                disabled: _ctx.isButton3Enable,
                "is-loading": _ctx.isBtn3Loading,
                "css-button": 'tw-whitespace-nowrap',
                onClick: _cache[2] || (_cache[2] = () => _ctx.$emit('click-button3'))
              }, null, 8, ["id", "class", "title", "disabled", "is-loading"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}